import { gql } from "@apollo/client"
import { MiniCompanyProfileFragment } from "@pallet/features/CompanyType/MiniCompanyProfile/fragments"
import { PostSectionFragment } from "@pallet/features/RecruitingTeamType/MiniTeamProfile/PostSection/fragments"
import { MiniTeamProfileActionRowFragment } from "./ActionRow/fragments"

export const MiniTeamProfileFragment = gql`
    fragment MiniTeamProfileFragment on RecruitingTeamType {
        id
        company {
            id
            ...MiniCompanyProfile_company
        }
        posts(onlyListed: true) {
            ...MiniTeamProfilePostSectionFragment
        }
        ...MiniTeamProfileActionRowFragment
    }
    ${MiniCompanyProfileFragment}
    ${PostSectionFragment}
    ${MiniTeamProfileActionRowFragment}
`
